module.exports = "<div style=\"position: absolute; display: table; width: 100%; height: 100%; width: 100vw; height: 100vh;\">\n    <div style=\"display: table-cell; vertical-align: middle; text-align: center; padding: 20px;\">\n        <h1>Page not found.</h1>\n        <p>¯\\_(ツ)_/¯</p>\n        <p><a href=\"/\" style=\"background: none; text-decoration: none; border: none;\">↩︎</a>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/notFound/notFound.html
// module id = 94
// module chunks = 0